
webpack.register(
    'components/alert-manager/alert/alert',
    function() {
        return require('components/alert-manager/alert/alert');
    },
    false
);
webpack.register(
    'components/alert-manager/disable-alert/disable-alert',
    function() {
        return require('components/alert-manager/disable-alert/disable-alert');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/alert-manager/alert/alert'/>\r\n<can-import from='components/alert-manager/disable-alert/disable-alert'/>\r\n\r\n<div class='c-alert-manager {{#withGap}}c-alert-manager--with-gap{{/withGap}}'>\r\n    {{#isEnable}}\r\n        {{#showDisableAlert}}\r\n            <alert-manager-disable-alert\r\n                (on-close-click)=\"onCloseDisableClick()\"\r\n                (on-alerts-disable)=\"onAlertsDisable()\"\r\n                {live}=\"currentAlert.live\"\r\n            />\r\n        {{/else}}\r\n            <alert-manager-alert\r\n                {alert}=\"currentAlert\"\r\n                {players-list}=\"playersList\"\r\n                (on-alert-hide)=\"onAlertHide()\"\r\n                (on-close-click)=\"onCloseAlertClick()\"\r\n            />\r\n        {{/showDisableAlert}}\r\n    {{/isEnable}}\r\n</div>\r\n");